import { render } from "./AddEditDevicePage.vue?vue&type=template&id=589bd874&scoped=true"
import script from "./AddEditDevicePage.vue?vue&type=script&lang=js"
export * from "./AddEditDevicePage.vue?vue&type=script&lang=js"

import "./AddEditDevicePage.vue?vue&type=style&index=0&id=589bd874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589bd874"]])

export default __exports__